import { instance as axios, setJwtToken } from "../../config/axiosInstance";


// ------------------------Get Notification-------------------
export const getNotificationListApi = async (data) => {
  const endPoint = `/admin/notification` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Add-Notification------------------
export const createNotificationAPI = async (data) => {
  const endPoint = `admin/notification`;
  return await axios.post(endPoint, data, setJwtToken());
};

// -------------------------Delete Notification ------------
export const deleteNotificationApi = async (id) => {
  const endPoint = `admin/notification/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};